export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f1bfa1a113847c2ed81812bd06f130d7a8a64e1fa&name=fetchTypeahead!'